import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('LAB_RESEARCH_POLICY_HOLDER_RELATION')